"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var react_sortable_hoc_1 = require("react-sortable-hoc");
var classNames = require("classnames");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var Thumb = /** @class */ (function (_super) {
    tslib_1.__extends(Thumb, _super);
    function Thumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Thumb.prototype.disableEditPhoto = function () {
        return !this.props.allowEdit || this.isUnsupportedBrowser;
    };
    Object.defineProperty(Thumb.prototype, "isUnsupportedBrowser", {
        get: function () {
            var msie = lodash_1.get($, 'browser.msie');
            var version = lodash_1.get($, 'browser.version');
            return msie && version && parseInt(version, 10) < 11;
        },
        enumerable: true,
        configurable: true
    });
    Thumb.prototype.edit = function () {
        this.props.onEdit(this.props.photo);
    };
    Thumb.prototype.remove = function () {
        this.props.onRemove(this.props.photo);
    };
    Thumb.prototype.renderEditLink = function () {
        var _this = this;
        if (this.disableEditPhoto()) {
            return null;
        }
        return (React.createElement("a", { className: "img-uploader__actions__action img-uploader__actions__action--edit", onClick: function () { return _this.edit(); } }, I18n.t('discovery.photos.thumb.edit')));
    };
    Thumb.prototype.render = function () {
        var _this = this;
        var className = classNames('img-uploader__thumb', {
            'img-uploader__thumb--with-warning': this.props.photo.showTooSmallWarning,
        });
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "img-uploader__thumb__image" },
                React.createElement("img", { src: this.props.photo.thumbUrl, role: "presentation" }),
                React.createElement("div", { className: "img-uploader__thumb__image__overlay" })),
            React.createElement("div", { className: "img-uploader__actions" },
                this.renderEditLink(),
                React.createElement("a", { className: "img-uploader__actions__action img-uploader__actions__action--remove", onClick: function () { return _this.remove(); } }))));
    };
    return Thumb;
}(React.Component));
Thumb.propTypes = {
    photo: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    allowEdit: PropTypes.bool.isRequired,
};
exports.default = react_sortable_hoc_1.SortableElement(Thumb); // eslint-disable-line new-cap
//# sourceMappingURL=thumb.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/thumb.js
// module id = Jxgb
// module chunks = 20 21